module.exports = __webpack_public_path__ + "static/media/No_will.6188ac0d.mp3";